function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "adjustments");

var _ref3 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 411.65646,
  cy: 723.2439,
  rx: 170.65646,
  ry: 31.7561,
  fill: "#f2f2f2"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 66,
  y: 88.25,
  width: 910,
  height: 490,
  fill: "#f2f2f2"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 890,
  y: 472.65136,
  width: 86,
  height: 105.59864,
  fill: "#3f3d56"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M1050.21429,603.54c0,20.5086-12.192,27.66944-27.23168,27.66944S995.75094,624.0486,995.75094,603.54s27.23167-46.59877,27.23167-46.59877S1050.21429,583.0314,1050.21429,603.54Z",
  transform: "translate(-86.5 -72.5)",
  fill: "#00c968"
});

var _ref7 = /*#__PURE__*/React.createElement("polygon", {
  points: "935.491 555.572 935.769 538.408 947.376 517.174 935.813 535.716 935.939 527.998 943.938 512.636 935.972 525.956 935.972 525.956 936.197 512.076 944.763 499.845 936.233 509.893 936.374 484.441 935.488 518.135 935.561 516.745 926.852 503.414 935.421 519.413 934.61 534.915 934.586 534.504 924.546 520.475 934.555 535.957 934.454 537.896 934.436 537.925 934.444 538.084 932.385 577.414 935.136 577.414 935.466 557.099 945.451 541.655 935.491 555.572",
  fill: "#3f3d56"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M219.5,116.5a22,22,0,1,1,22-22A22.02489,22.02489,0,0,1,219.5,116.5Zm0-42a20,20,0,1,0,20,20A20.02292,20.02292,0,0,0,219.5,74.5Z",
  transform: "translate(-86.5 -72.5)",
  fill: "#3f3d56"
});

var _ref9 = /*#__PURE__*/React.createElement("circle", {
  cx: 13,
  cy: 129,
  r: 13,
  fill: "#3f3d56"
});

var _ref10 = /*#__PURE__*/React.createElement("circle", {
  cx: 1014,
  cy: 224,
  r: 13,
  fill: "#3f3d56"
});

var _ref11 = /*#__PURE__*/React.createElement("rect", {
  x: 189.5,
  y: 188.25,
  width: 664,
  height: 6,
  fill: "#3f3d56"
});

var _ref12 = /*#__PURE__*/React.createElement("rect", {
  x: 189.5,
  y: 242.25,
  width: 664,
  height: 6,
  fill: "#3f3d56"
});

var _ref13 = /*#__PURE__*/React.createElement("rect", {
  x: 189.5,
  y: 296.25,
  width: 664,
  height: 6,
  fill: "#3f3d56"
});

var _ref14 = /*#__PURE__*/React.createElement("rect", {
  x: 302.5,
  y: 166.25,
  width: 16,
  height: 50,
  fill: "#00c968"
});

var _ref15 = /*#__PURE__*/React.createElement("rect", {
  x: 484.5,
  y: 220.25,
  width: 16,
  height: 50,
  fill: "#00c968"
});

var _ref16 = /*#__PURE__*/React.createElement("rect", {
  x: 796.5,
  y: 274.25,
  width: 16,
  height: 50,
  fill: "#00c968"
});

var _ref17 = /*#__PURE__*/React.createElement("rect", {
  x: 189.5,
  y: 420.25,
  width: 236,
  height: 6,
  fill: "#3f3d56"
});

var _ref18 = /*#__PURE__*/React.createElement("rect", {
  x: 189.5,
  y: 442.25,
  width: 118,
  height: 6,
  fill: "#3f3d56"
});

var _ref19 = /*#__PURE__*/React.createElement("polygon", {
  points: "225.5 500.25 188.5 500.25 188.5 463.25 224.5 463.25 224.5 465.25 190.5 465.25 190.5 498.25 223.5 498.25 223.5 479.439 225.5 479.439 225.5 500.25",
  fill: "#3f3d56"
});

var _ref20 = /*#__PURE__*/React.createElement("rect", {
  x: 617.5,
  y: 420.25,
  width: 236,
  height: 6,
  fill: "#3f3d56"
});

var _ref21 = /*#__PURE__*/React.createElement("rect", {
  x: 617.5,
  y: 442.25,
  width: 76,
  height: 6,
  fill: "#3f3d56"
});

var _ref22 = /*#__PURE__*/React.createElement("rect", {
  x: 777.5,
  y: 442.25,
  width: 76,
  height: 6,
  fill: "#3f3d56"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M740,572.75H703v-37h37Zm-35-2h33v-33H705Z",
  transform: "translate(-86.5 -72.5)",
  fill: "#3f3d56"
});

var _ref24 = /*#__PURE__*/React.createElement("polygon", {
  points: "378.024 333.278 351.768 333.278 351.768 320.418 373.737 320.418 378.56 323.097 378.024 333.278",
  fill: "#575a89"
});

var _ref25 = /*#__PURE__*/React.createElement("polygon", {
  points: "332.478 687.469 333.549 706.76 349.625 703.545 346.945 684.254 332.478 687.469",
  fill: "#ffb9b9"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M495.06711,749.78838s.53585,16.07524-1.07168,20.362,4.28673,6.4301,4.28673,6.4301h12.86019l7.50178,1.07168V769.6145s-8.57346-13.396-8.57346-20.8978S495.06711,749.78838,495.06711,749.78838Z",
  transform: "translate(-86.5 -72.5)",
  fill: "#ffb9b9"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M421.65687,776.0446s10.71683-5.06307,14.46771-1.99569S453.80734,803.3725,448.44893,804.98c0,0-3.75089,6.4301-16.61108,2.14337s-12.86018-9.1093-12.86018-9.1093-3.75089-3.21505-3.75089-4.28673,1.60752-10.71683,1.60752-10.71683,1.189-8.06968,3.00577-7.51781Z",
  transform: "translate(-86.5 -72.5)",
  fill: "#2f2e41"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M496.1388,768.007s-1.60753-1.60752-2.67921,0-6.96594,21.96949-1.60752,23.04117,13.396,4.82257,14.46771,3.75089a14.68006,14.68006,0,0,0,2.14336-3.75089s8.57346,3.75089,11.25267,6.96594,34.82968,10.181,33.758,0-17.14691-18.75445-17.14691-18.75445l-17.68276-11.7885s-6.96594.53584-8.57346,3.75089S497.21048,773.90123,496.1388,768.007Z",
  transform: "translate(-86.5 -72.5)",
  fill: "#2f2e41"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M339.13733,560.63644s-5.89425,7.50178-4.82257,8.03762,24.64869,5.89425,37.50888,2.67921,39.65225-2.67921,41.25977-6.4301,21.43365-50.36907,21.43365-50.36907L428.087,479.18858l-6.96594-9.1093-16.07524-13.93187-32.15047,60.01421Z",
  transform: "translate(-86.5 -72.5)",
  fill: "#575a89"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M339.13733,560.63644s-5.89425,7.50178-4.82257,8.03762,24.64869,5.89425,37.50888,2.67921,39.65225-2.67921,41.25977-6.4301,21.43365-50.36907,21.43365-50.36907L428.087,479.18858l-6.96594-9.1093-16.07524-13.93187-32.15047,60.01421Z",
  transform: "translate(-86.5 -72.5)",
  opacity: 0.1
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M407.18916,547.77625s-7.50178,26.79206,0,63.7651.53584,45.01066,2.14336,46.61819,2.14337,1.07168,2.14337,2.6792,1.60752,9.1093,0,11.78851-1.60752,87.87795,3.21505,90.02132,18.75444,7.50177,21.43364,0,.53584-61.62174,1.60753-64.30094,1.07168-9.1093,1.07168-10.71683,3.21505-19.82612,3.75089-24.64869S444.698,648.5144,444.698,648.5144s-1.07168-38.04473,2.14337-49.29739,4.28673-12.32435,4.28673-12.32435l25.72037,66.98015s-2.14336,6.96593,0,9.1093-.53584,1.60752,1.60753,5.35841,4.28673,4.82257,4.28673,6.96594-2.14337,2.14336-1.07169,3.75088,2.67921,7.50178,2.67921,7.50178l-2.67921,6.43009s1.60753,13.396,3.75089,21.43365,2.14337,40.72393,4.82257,41.25977,23.577,6.4301,23.577-5.89425-1.60753-65.90847-1.60753-65.90847-3.215-8.03761-3.215-10.181-.53584-3.21505.53585-4.28673,2.14336-3.215.53584-4.82257-1.07169-3.75089-1.07169-5.89425a46.89912,46.89912,0,0,0-1.07168-8.57346c-.53584-2.14337-10.71682-69.12351-10.71682-69.12351s2.14336-8.03762,0-8.57346-2.14337-4.82257-2.14337-6.96594,5.35842-28.93542-1.07168-28.93542S407.18916,547.77625,407.18916,547.77625Z",
  transform: "translate(-86.5 -72.5)",
  fill: "#2f2e41"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M336.45812,515.62578l-7.50177,3.75089s-26.79206,14.46771-15.00356,22.50533,23.577-11.25266,23.577-11.25266l11.25266-8.57346Z",
  transform: "translate(-86.5 -72.5)",
  fill: "#ffb9b9"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M440.94715,368.8053s-2.14336,24.64869-13.396,30.0071-3.75088,45.5465-3.75088,45.5465l15.53939,15.00356,27.3279-8.03762,3.21505-18.2186,2.6792-18.75444-6.43009-9.64514s-8.03762-2.14337-4.82257-23.577S440.94715,368.8053,440.94715,368.8053Z",
  transform: "translate(-86.5 -72.5)",
  fill: "#ffb9b9"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M424.87192,407.38586s12.32435,40.72393,20.8978,40.72393,13.396-9.64514,14.46772-21.43364,8.03761-24.6487,8.03761-24.6487L484.88613,417.031s13.396,118.42091,12.32435,121.636-42.8673,6.96594-59.47837,11.78851S404.51,551.52714,404.51,548.84794c0-2.38617,8.50073-23.04889,2.03221-38.13966a62.863,62.863,0,0,1-4.74647-16.87547c-1.00113-7.94439-1.93086-17.55771-1.03662-20.53848,1.60752-5.35841,10.181-62.15758,10.181-62.15758Z",
  transform: "translate(-86.5 -72.5)",
  fill: "#00c968"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "M433.94457,392.601s-9.60849,5.13969-13.89522,7.28306-30.543,8.57346-31.07879,11.7885,3.75089,48.22571,1.60752,53.04828-23.577,47.68987-23.577,47.68987l-1.07168,9.1093s-35.36552,42.33145-31.07879,47.154,20.362-15.00355,20.362-15.00355,35.90136-57.335,36.97305-59.47838,23.04117-41.79561,26.25621-42.86729,10.71683-46.08234,11.78851-48.22571S435.51545,391.74808,433.94457,392.601Z",
  transform: "translate(-86.5 -72.5)",
  fill: "#575a89"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M391.64977,411.13675h-3.215s-11.78851,45.01066-15.00355,50.90491-3.75089,15.5394-4.28673,17.14692-2.67921,1.07168-3.215,4.82257-5.89425,8.57346-10.181,10.71683-23.577,20.362-23.04117,20.8978,6.43009,19.29028,10.181,19.29028,18.75444-18.2186,20.362-18.2186,8.57346-6.43009,9.64514-6.96593,28.39959-50.90491,27.3279-63.22926S391.64977,411.13675,391.64977,411.13675Z",
  transform: "translate(-86.5 -72.5)",
  fill: "#575a89"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "M525.34922,549.95865l6.60019,5.17525s23.35781,19.5331,10.20012,25.051-20.85061-15.74008-20.85061-15.74008L511.988,553.79437Z",
  transform: "translate(-86.5 -72.5)",
  fill: "#ffb9b9"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "M460.65418,393.23614s7.085,3.4329,10.30008,6.11211,27.86374,9.64514,27.86374,11.7885-2.6792,35.36552-2.6792,35.36552l3.75088,58.94253s5.35842,66.44431,6.4301,68.05183,2.6792,10.181,0,10.181-16.07524-15.00355-15.5394-22.50533,4.28673-24.64869.53585-28.93542-21.43365-76.08945-21.43365-80.37618-7.50178-47.154-6.96594-48.22571S460.65418,393.23614,460.65418,393.23614Z",
  transform: "translate(-86.5 -72.5)",
  fill: "#575a89"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  d: "M490.78038,410.60091l8.03762.53584,19.82613,80.912s1.60752,10.181,2.14336,11.25267,8.57346,47.68986,5.35841,49.29738-13.93187,7.50178-14.46771,3.75089-5.89425-24.64869-11.25266-29.47126-10.71683-87.878-10.71683-87.878Z",
  transform: "translate(-86.5 -72.5)",
  fill: "#575a89"
});

var _ref40 = /*#__PURE__*/React.createElement("circle", {
  cx: 372.12991,
  cy: 288.80352,
  r: 21.96949,
  fill: "#ffb9b9"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  d: "M443.29826,362.908c1.39789-.71805,3.23729-.04219,4.52757,1.52069a21.44281,21.44281,0,0,1,31.166-14.48838v-2.23328a18.554,18.554,0,0,0-18.554-18.554h-4.45967A34.8571,34.8571,0,0,0,421.121,364.01013v6.22124A31.25133,31.25133,0,0,0,438.235,398.10493l20.064-10.62211a21.44539,21.44539,0,0,1-10.74064-15.93235c-1.69792.74136-3.97171-.45849-5.15459-2.7613C441.18669,366.42005,441.58726,363.787,443.29826,362.908Z",
  transform: "translate(-86.5 -72.5)",
  fill: "#2f2e41"
});

var _ref42 = /*#__PURE__*/React.createElement("polyline", {
  points: "195.583 475.174 206.5 487.5 230.364 464.108",
  fill: "none",
  stroke: "#57b894",
  strokeMiterlimit: 10,
  strokeWidth: 4
});

var SvgConfiguration = function SvgConfiguration(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "eaae95e9-bf99-4a62-939f-b246d44eba2f",
    "data-name": "Layer 1",
    width: 1027,
    height: 755,
    viewBox: "0 0 1027 755",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgConfiguration, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Configuration.aeea97fd.svg";
export { ForwardRef as ReactComponent };